import { render, staticRenderFns } from "./ProcessDialog.vue?vue&type=template&id=0cdbb791&scoped=true&"
import script from "./ProcessDialog.vue?vue&type=script&lang=js&"
export * from "./ProcessDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cdbb791",
  null
  
)

export default component.exports